import jwtDecode from "jwt-decode";

export const permission = {
	CREATE: "c",
	READ: "r",
	UPDATE: "u",
	DELETE: "d",
	READ_ALL: "t",
	UPDATE_ALL: "y",
	READ_SELF: "i",
	SCHEDULE_READ: "s",
	ADMIN_EDIT_PERMISSION: "a_e_p",
};

export const additionalPermission = {
	CLAIM: {
		PETTY_CASH: ":pc:",
	},
	REPORT: {
		PART_TIME_WAGE: ":ptw:",
	},
};

export const models = {
	ADMIN: "admin",
	MENU: "menu",
	ORDER: "order",
	POINTS: "points",
	TRANSACTION: "transaction",
	USER: "user",
	COFFEE: "coffee",
	ROLE: "role",
	COURSE: "course",
	STUDENT: "student",
	STAFF_APPLICATION: "staff_application",
	PART_TIME: "part_time",
	REPORT: "report",
	LESSON_RECORD: "lesson_record",
	ATTENDANCE: "attendance",
	CHATGPT: "chatgpt",
	CLAIM: "claim",
};

export const permissionCheck = (token, model, permissions, check = "and", redirect = false) => {
	try {
		const { role } = jwtDecode(token);
		for (const permission of permissions) {
			if (check === "and" && !role[model]?.includes(permission)) return false;
			if (check === "or" && role[model]?.includes(permission)) return true;
		}
		if (check === "or") return false;
		return true;
	} catch (error) {
		if (redirect) window.location.href = "/";
		else return false;
	}
};
